import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'd3-array';

import { timeHour } from 'd3-time';

import AGPGraph from './AGPGraph';
import AGPLabels from './AGPLabels';
import BaseSVG, { zeroMargins } from './BaseSVG';
import D3Component from './D3Component';
import GlucoseDayGraph from './GlucoseDayGraph';
import GlucoseSVG from './GlucoseSVG';
import MainView from './MainView';
import PresentationContext from '../PresentationContext';
import { parseDate } from '../utils/formats';

function AGPReport(props) {
  const {
    formatDateRange,
    formatGlucose,
    formatGlucoseValue,
    locale,
  } = useContext(PresentationContext);
  const {
    days,
    interactive = true,
    percentile,
    smbgData = {},
    sgvData = {},
    t,
    timeScale,
  } = props;
  const firstDay = parseDate(Object.keys(sgvData).sort()[0]);
  const title = t('agp.title', { timeRange: formatDateRange(days) });

  const sgv = merge(Object.values(sgvData));
  const smbg = merge(Object.values(smbgData));
  
  const showWebGraph = !sgv.length && !!smbg.length;

  return (
    <MainView
      description={t('agp.description')}
      heading={t('agp.heading')}
      interactive={interactive}
      key="mainView"
      title={title}>
      <section>
        <GlucoseSVG
          key="mainGraph"
          times={[firstDay, timeHour.offset(firstDay, 24)]}
          yLabel={<AGPLabels t={t}/>}
        >
          {showWebGraph
          ? (
            <D3Component graph={GlucoseDayGraph} data={{ smbg, sgv }} days={days} formatGlucose={formatGlucose} locale={locale} t={t} timeScale={timeScale} />
          )
          : (
            <D3Component graph={AGPGraph} data={sgvData} formatGlucoseValue={formatGlucoseValue} locale={locale} percentile={percentile} t={t}/>
          )}
        </GlucoseSVG>
      </section>
      <section>
        <BaseSVG height={0} svgWidth={0} svgHeight={0} margins={zeroMargins} showXAxis={false} key="firstAdditionalGraph" />
      </section>
      <section>
        <BaseSVG height={0} svgWidth={0} svgHeight={0} margins={zeroMargins} showXAxis={false} key="secondAdditionalGraph" />
      </section>
    </MainView>
  );
}

AGPReport.propTypes = {
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
  sgvData: PropTypes.object.isRequired,
  interactive: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default AGPReport;
